import React from 'react';
import { 
  Card,
  CardContent,
  CardHeader,
  Divider,
  Collapse,
  IconButton,
  Typography
} from '@mui/material';
import { Category as CategoryIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@mui/icons-material';
import ProductVariation from '../productVariation/ProductVariation.jsx';

const VariationsSection = ({ product, expanded, toggleSection }) => {
  return (
    <Card sx={{ mt: 4, borderLeft: '4px solid rgb(110, 67, 183)' }}>
      <CardHeader
        avatar={<CategoryIcon style={{ color: '#673ab7' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#673ab7' }}>
            Product Variations
          </Typography>
        }
        action={
          <IconButton onClick={() => toggleSection('variations')}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        sx={{ backgroundColor: '#f5f5f5' }}
      />
      <Divider />
      <Collapse in={expanded}>
        <CardContent>
          <ProductVariation product={product} />
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default VariationsSection;
